import React, { useMemo } from 'react'
import moment from 'moment'
import Drawer from 'components/shared/Drawer'
import ExtensiveFmcsaDetails from './ExtensiveFmcsaDetails'
import { DrawerHeading, FmcsaNotFound } from './FmcsaSummary'
import { buildExtensive } from './fmcsaViewModel'

const ExtensiveFmcsaDrawer = ({ open, onClose, data, requestedAt, legalName, dot }) => {
    const extensive = useMemo(() => buildExtensive(data), [data])

    return (
        <Drawer
            open={open}
            onClose={onClose}
            title={(
                <DrawerHeading
                    title="Extensive FMCSA Details"
                    subtitle={requestedAt ? `Requested ${moment(requestedAt).format('MMM D, YYYY')}` : null}
                />
            )}
        >
            {extensive
                ? <ExtensiveFmcsaDetails extensive={extensive} legalName={legalName} dot={dot} />
                : <FmcsaNotFound dot={dot} />}
        </Drawer>
    )
}

export default ExtensiveFmcsaDrawer
